import { Controller } from "@hotwired/stimulus"

// Compte à rebours du bandeau de prise de contrôle.
// La seule autorité sur l'expiration reste le serveur (cf.
// ImpersonationSupport) : ce contrôleur ne fait qu'afficher le temps restant
// et recharger la page une fois l'échéance passée, pour que l'administrateur
// voie immédiatement qu'il a retrouvé son identité.
export default class extends Controller {
  static targets = ["remaining"]
  static values = { expiresAt: String }

  connect() {
    if (!this.hasExpiresAtValue) return
    this.deadline = Date.parse(this.expiresAtValue)
    if (Number.isNaN(this.deadline)) return

    this.render()
    this.timer = setInterval(() => this.render(), 15000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  render() {
    const restant = this.deadline - Date.now()

    if (restant <= 0) {
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    if (!this.hasRemainingTarget) return

    const minutes = Math.ceil(restant / 60000)
    this.remainingTarget.textContent =
      minutes > 1 ? `Retour auto dans ${minutes} min` : "Retour auto dans moins d'une minute"
  }
}
